import { IHelpContextRepository } from "@/core/repositories/helpContext";

export class GetIsFirstTimeDeductionPageUseCase {
  private readonly helpContextRepository: IHelpContextRepository;
  constructor(helpContextRepository: IHelpContextRepository) {
    this.helpContextRepository = helpContextRepository;
  }

  async execute(): Promise<boolean> {
    return await this.helpContextRepository.isFirstDeductionPage();
  }
}
